import { ErrorHandler, Injectable } from '@angular/core';
import { LegacyServiceWorkerCleanupService } from 'app/services/legacy-service-worker-cleanup.service';

const CHUNK_RELOAD_GUARD_KEY = 'portal.chunk-reload-at';
const CHUNK_RELOAD_GUARD_MS = 10_000;

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  constructor(
    private readonly _legacyCleanup: LegacyServiceWorkerCleanupService
  ) {}

  handleError(error: any): void {
    if (this.isChunkLoadError(error)) {
      void this.reloadAfterClearingStaleCaches();
      return;
    }

    console.error(error);
  }

  private isChunkLoadError(error: any): boolean {
    const message = error?.message ?? '';
    return (
      message.includes('Failed to fetch dynamically imported module') ||
      message.includes('Importing a module script failed')
    );
  }

  private async reloadAfterClearingStaleCaches(): Promise<void> {
    if (this.hasReloadedRecently()) {
      console.error('Chunk load failed after reload; not retrying.');
      return;
    }

    this.markReloadAttempt();
    console.warn('Chunk load failed. Reloading...');
    await this._legacyCleanup.cleanup();
    window.location.reload();
  }

  private hasReloadedRecently(): boolean {
    const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_GUARD_KEY));
    return Number.isFinite(lastReloadAt) && Date.now() - lastReloadAt < CHUNK_RELOAD_GUARD_MS;
  }

  private markReloadAttempt(): void {
    sessionStorage.setItem(CHUNK_RELOAD_GUARD_KEY, String(Date.now()));
  }
}
